import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  min-width: 900px;
  overflow: auto;

  @media (max-width: 900px) {
    flex-direction: column;
    flex-wrap: wrap;
  }
`;

export const Box = styled.div`
  width: 100%;
  max-width: 633px;
  min-width: 420px;
  overflow: auto;
  border-radius: 8px;
  padding: 10px 30px 22px 32px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
`;

export const Title = styled.span`
  font-weight: 600;
  font-size: 20px;
  text-align: start;
  line-height: 55px;
  align-self: start;
  color: #343c6a;
`;

export const Content = styled.div`
  width: 100%;
  min-height: 684px;
  height: auto;
  line-height: 2rem;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 21px;
`;

export const ImageUploadContainer = styled.div`
  margin-bottom: 1rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 36px;
`;

export const TarmoqlarWrapper = styled.div``;

export const TarmoqlarTitle = styled.div`
  margin-top: 12px;
  margin-bottom: -5px;
  font-weight: 500;
  font-size: 14px;
  /* line-height: 16px; */
  color: #343c6a;
`;
